import { capitalize } from 'lodash'
import React from 'react'
import workflowTasksTypeLabels from '../WorkflowTasksTypeLabels'

const WorkflowTaskName: React.FC<{ task: string; useCapitalCase?: boolean }> = ({
    task,
    useCapitalCase: useCapital = false,
}) => <>{workflowTasksTypeLabels[task] || (useCapital ? capitalize(task) : task)}</>
export default WorkflowTaskName
